import classNames from "classnames";
import React from "react";
import Text from "../../Text/Text";
import { findDataAttrProps } from "../../../utils/props";
import styles from "./ButtonLike.module.scss";

export interface ButtonLikeProps {
  children: React.ReactNode;
  primary?: boolean;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
}

function createButtonLike<P>(
  Component: React.ComponentType<P>,
  displayName: string
) {
  const ButtonLike = React.forwardRef<HTMLButtonElement, P & ButtonLikeProps>(
    (props, ref) => {
      const { children, primary, className, ...rest } = props;
      return (
        <Component
          {...findDataAttrProps(props)}
          className={classNames(
            "ButtonLike",
            styles.button,
            primary ? styles.primary : styles.secondary,
            props.disabled && styles.disabled,
            className && className
          )}
          // Remaining props must all be from P.
          // tslint:disable-next-line: no-any
          {...(rest as any)}
          ref={ref}
        >
          <Text variant="button" as="div" className={styles.children}>
            {children}
          </Text>
        </Component>
      );
    }
  );
  ButtonLike.displayName = displayName;
  return ButtonLike;
}

export default createButtonLike;
